"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
exports.default = reducer;
var immutable_1 = require("immutable");
var state_types_1 = require("./state-types");
var actions = __importStar(require("./actions"));
var AVATAR_CACHE_MAX = 500;
exports.initialState = (0, immutable_1.Map)({
    profilePictures: (0, immutable_1.Map)({
        data: (0, immutable_1.Map)(),
        processing: false,
        error: null,
    }),
    avatarUpload: (0, immutable_1.Map)({
        processing: false,
        error: null,
        success: false,
    }),
    avatarDelete: (0, immutable_1.Map)({
        processing: false,
        error: null,
        success: false,
    }),
});
function reducer(state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        case actions.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING:
            return state.setIn(['avatarUpload', 'processing'], action.payload);
        case actions.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS:
            return state
                .setIn(['avatarUpload', 'success'], true)
                .setIn(['avatarUpload', 'error'], null)
                .setIn(['avatarUpload', 'processing'], false);
        case actions.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR:
            return state
                .setIn(['avatarUpload', 'error'], action.payload)
                .setIn(['avatarUpload', 'success'], false)
                .setIn(['avatarUpload', 'processing'], false);
        case actions.SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING:
            return state.setIn(['avatarDelete', 'processing'], action.payload);
        case actions.SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS:
            return state
                .setIn(['avatarDelete', 'success'], true)
                .setIn(['avatarDelete', 'error'], null)
                .setIn(['avatarDelete', 'processing'], false);
        case actions.SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR:
            return state
                .setIn(['avatarDelete', 'error'], action.payload)
                .setIn(['avatarDelete', 'success'], false)
                .setIn(['avatarDelete', 'processing'], false);
        case actions.SET_COMMUNITY_PROFILE_PICTURES: {
            // fromJS returns the wide JS-to-Immutable union; we know the action
            // payload is a flat string-keyed object, so this is the single
            // permitted Immutable boundary cast in the reducer.
            var incoming = (0, immutable_1.fromJS)(action.payload || {});
            var existing = state.getIn(['profilePictures', 'data']);
            var previous = (0, state_types_1.isStringMap)(existing) ? existing : (0, immutable_1.Map)();
            var merged = previous.merge(incoming);
            // FIFO eviction: drops the earliest insertion-order entries once the cap
            // is exceeded. Immutable.Map preserves insertion order, so .slice drops
            // the oldest entries (not the least-recently-used ones).
            var trimmed = merged.size > AVATAR_CACHE_MAX
                ? merged.slice(merged.size - AVATAR_CACHE_MAX)
                : merged;
            return state
                .setIn(['profilePictures', 'data'], trimmed)
                .setIn(['profilePictures', 'error'], null);
        }
        case actions.SET_COMMUNITY_PROFILE_PICTURES_PROCESSING:
            return state.setIn(['profilePictures', 'processing'], action.payload);
        case actions.SET_COMMUNITY_PROFILE_PICTURES_ERROR:
            return state.setIn(['profilePictures', 'error'], action.payload);
        default:
            return state;
    }
}
